import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { sqSummaryReportStore } from '@/core/core.stores';
import { ButtonGroup, ToolbarButton } from '@seeqdev/qomponents';
import { setIsItemsOverlaid } from '@/summaryReport/summaryReport.actions';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';

interface SummaryReportToolbarProps {
  size?: 'default' | 'sm' | 'xs';
}

export const SummaryReportToolbar: React.FunctionComponent<SummaryReportToolbarProps> = ({ size = 'default' }) => {
  const { t } = useTranslation();

  const isOverlaid = useFluxPath(sqSummaryReportStore, () => sqSummaryReportStore.isItemsOverlaid);

  const isSmall = size === 'sm';

  const viewButtonsConfiguration = [
    {
      id: 'overlayChartsBtn',
      icon: 'fa-arrow-right-arrow-left',
      label: t('INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.OVERLAY'),
      tooltipText: t('INVESTIGATE_TOOLS.SUMMARY_REPORT.TOOLBAR.OVERLAY_TOOLTIP'),
      onClick: () => setIsItemsOverlaid(!isOverlaid),
      trackAction: 'overlay Statistics Summary',
    },
  ];

  return (
    <div className="flexColumnContainer flexAlignBottom">
      <ButtonGroup
        extraClassNames="forceFlex flexCenter widthUnset pl3 pr3 button-group-br"
        buttons={[
          ..._.map(viewButtonsConfiguration, (config) => ({
            variant: 'element' as const,
            element: (
              <ToolbarButton
                key={config.id}
                icon={classNames(config.icon, { 'fa-lg': !isSmall })}
                label={config.label}
                isSmall={isSmall}
                id={config.id}
                testId={config.id}
                tooltipText={config.tooltipText}
                tooltipOptions={{ position: 'top' }}
                onClick={config.onClick}
              />
            ),
          })),
        ]}
      />
    </div>
  );
};
